'use client'

import type { Newsroom } from '@/payload-types'
import { NewsroomCard } from './NewsroomCard'
import { CardCarousel } from '@/components/ui/card-carousel'

interface Props {
  articles: Newsroom[]
  autoplayDelay?: number
}

export function NewsroomCardCarousel({ articles, autoplayDelay = 10000 }: Props) {
  return (
    <CardCarousel
      items={articles}
      keyExtractor={(a) => String(a.id)}
      renderDarkCard={(article) => <NewsroomCard article={article} variant="dark" />}
      renderLightCard={(article) => <NewsroomCard article={article} variant="light" />}
      ariaLabel="Featured articles carousel"
      autoplayDelay={autoplayDelay}
    />
  )
}
